const getActions = (dispatch)=>{
    const updatePurchaseType = (purchaseType)=>{
        dispatch({
            type: 'setPurchaseType',
            payload: {
                purchaseType
            }
        });
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'resetErrors'
        });
    };
    const updateDeliveryInterval = (deliveryInterval)=>{
        dispatch({
            type: 'setDeliveryInterval',
            payload: {
                deliveryInterval
            }
        });
        dispatch({
            type: 'updateIsConfiguratorValid'
        });
    };
    const updateQuantity = (quantity)=>{
        dispatch({
            type: 'setQuantity',
            payload: {
                quantity
            }
        });
    };
    const triggerValidationErrors = ()=>{
        dispatch({
            type: 'updateAllValidations'
        });
        dispatch({
            type: 'triggerErrors'
        });
    };
    return {
        updatePurchaseType,
        updateDeliveryInterval,
        updateQuantity,
        triggerValidationErrors
    };
};

export { getActions };
//# sourceMappingURL=actions.js.map
